import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addNotification, setUnreadCount, showToast, dismissToast } from '../store/slices/notificationSlice';

const useNotificationSocket = (socket) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!socket) return;

    const handleNewNotification = (data) => {
      dispatch(addNotification(data));
      // Show toast for non-billing-tick notifications
      if (data.type !== 'billing.tick') {
        dispatch(showToast({
          id: data.id,
          title: data.title,
          body: data.body,
          type: data.type,
          deepLink: data.deep_link,
        }));
        setTimeout(() => dispatch(dismissToast()), 5000);
      }
    };

    const handleCountUpdate = (data) => {
      dispatch(setUnreadCount(data.count));
    };

    socket.on('new_notification', handleNewNotification);
    socket.on('notification_count_updated', handleCountUpdate);

    return () => {
      socket.off('new_notification', handleNewNotification);
      socket.off('notification_count_updated', handleCountUpdate);
    };
  }, [socket, dispatch]);
};

export default useNotificationSocket;
